// Swiper core
import Swiper from 'swiper';
// Swiper styles
import 'swiper/css';
export var HoldPageController = {
    init: function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.initChooseCountryCarrousel();
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    initChooseCountryCarrousel: function () {
        var swiperOptions = {
            slidesPerView: 5,
            spaceBetween: 0,
            loop: false,
            speed: 400,
            breakpoints: {
                0: {
                    slidesPerView: 2,
                },
                769: {
                    slidesPerView: 4,
                },
                1025: {
                    slidesPerView: 5,
                },
            },
        };
        var swiper = new Swiper('.country-accordion-swiper', swiperOptions);
        var slides = Array.from(swiper.slides);
        var nextBtn = document.querySelector('.accordion-next');
        var prevBtn = document.querySelector('.accordion-prev');
        var openIndex = 0;
        function setOpenSlide(index) {
            slides.forEach(function (slide, i) {
                slide.classList.toggle('is-open', i === index);
            });
            openIndex = index;
            updateNavState();
        }
        function ensureVisible() {
            var first = swiper.activeIndex;
            var visible = swiper.params.slidesPerView || 1;
            var last = first + visible - 1;
            if (openIndex < first) {
                swiper.slideTo(openIndex);
            }
            else if (openIndex > last) {
                swiper.slideTo(openIndex - (visible - 1));
            }
        }
        function updateNavState() {
            if (!nextBtn || !prevBtn)
                return;
            var isFirst = openIndex === 0;
            var isLast = openIndex === slides.length - 1;
            prevBtn.classList.toggle('nav-disabled', isFirst);
            nextBtn.classList.toggle('nav-disabled', isLast);
        }
        setOpenSlide(openIndex);
        ensureVisible();
        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                if (openIndex < slides.length - 1) {
                    setOpenSlide(openIndex + 1);
                    ensureVisible();
                }
            });
        }
        if (prevBtn) {
            prevBtn.addEventListener('click', function () {
                if (openIndex > 0) {
                    setOpenSlide(openIndex - 1);
                    ensureVisible();
                }
            });
        }
        swiper.on('click', function (sw) {
            var idx = sw.clickedIndex;
            if (idx !== undefined && idx >= 0) {
                setOpenSlide(idx);
                ensureVisible();
            }
        });
        swiper.on('slideChange', function () {
            ensureVisible();
            updateNavState();
        });
    },
};
